<template>
  <div class="p-4">
    <ComposableTable
      class="border rounded"
      :tier="true"
      :ignoreDefaultWidth="true"
     :data="sortedOrderingData"
     :loading="false"
     :columns="columns"
     :variables="variables"
     :white-bg="true"
     :page-size="200"
      @update-column-order="updateColumnOrder"

      :sort="sort"
      :order="order"
      @set-sort="setSort"
      @set-order="setOrder"
    >
      <template #after-last-row>
        <TableRowAction
          message="Add new tier price"
          :always-show="true"
          @open="$emit('add')"
        />
      </template>


      <template #cell-from_qty="{ item }">
        <input
          class="inp"
          type="number"
          :value="item.from_qty !== '---' ? item.from_qty : ''"
          @input="evt => setVal(evt.target.value, item.id, 'from_qty')"
        >
      </template>

      <template #cell-to_qty="{ item }">
        <input
          class="inp"
          type="number"
          :value="item.to_qty !== '---' ? item.to_qty : ''"
          @input="evt => setVal(evt.target.value, item.id, 'to_qty')"
        >
      </template>

      <template #cell-price="{ item }">
        <span>
          € <input
            class="inp"
            type="number"
            :value="item.price !== '---' ? item.price : ''"
            @input="evt => setVal(evt.target.value, item.id, 'price')"
          >
        </span>
      </template>


      <template #row-action="{item, rowIndex}">
        <div class="delete-icon" @click="$emit('remove', tier_prices.findIndex(tier => tier.id === item.id))">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="15" height="15">
            <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clip-rule="evenodd" />
          </svg>
        </div>
      </template>
    </ComposableTable>
  </div>
</template>

<script>

import simpleReodering from "@/components/Product/ComposableTable/simple-reodering"
import ComposableTable from "@/components/Product/ComposableTable/ComposableTable"
import TableRowAction from "@/layout/TableComposables/TableRowAction"

export default {
  mixins: [
    simpleReodering({
      dataSource: "computedData",
      key: "tier-prices",
      columns: ["From", "To", "Price"],
      variables: ['from_qty', "to_qty", 'price'],
    }),
  ],
  components: {
    ComposableTable,
    TableRowAction,
  },
  props: {
    value: Array,
  },
  created() {
    this.processValue()
  },
  data() {
    return {
      tier_prices: this.value,
    }
  },
  methods: {
    update() {
      this.$emit("input", this.tier_prices.slice())
    },

    processValue() {
      this.tier_prices = this.tier_prices.map(tier => ({ ...tier, price: tier && tier.price.replace ? tier.price.replace(/\./, ",") : (tier.price || "") }))
    },
    //
    setVal(newVal, id, field) {
      const i = this.tier_prices.findIndex(tier => tier.id === id)
      if (i < 0) return;

      switch (field) {
        case "price": {
          newVal = (newVal && newVal.replace) ? newVal.replace(/\,/, ".") : newVal
          break;
        }
        default: {
          newVal = parseInt(newVal, 10)
          break;
        }
      }

      this.tier_prices.splice(i, 1, { ...this.tier_prices[i], [field]: newVal })
      this.update()
    },
  },
  computed: {
    computedData() {
      return this.tier_prices.filter(price => price.state !== "removed").map(item => ({...item, _isReady: true}))
    },
  },
  watch: {
    value() {
      this.tier_prices = this.value
      this.processValue()
    },
  },
}

</script>

<style scoped>

.inp {
  border: none;
  padding: none;
}

.delete-icon {
  color: var(--red);
}

.delete-icon:hover {
  color: var(--red);
  filter: brightness(1.10);
}

</style>
